module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "gravatar-group"
  }, _vm._l(((Math.min(4, _vm.emails.length))), function(i) {
    return _c('img', {
      attrs: {
        "src": _vm.getGravatar(_vm.emails[i - 1])
      },
      on: {
        "load": _vm.imgLoaded
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55200f8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/global/GravatarGroup.vue
// module id = 539
// module chunks = 234